export default __webpack_public_path__ + "static/media/fourth.d9ead535.png";